import React from "react";
import PropTypes from "prop-types";
import styles from "./LoadingWrapper.module.scss";

const LoadingWrapper = ({ isLoading, children, displayRelative = true }) => (
  <div
    className={`${displayRelative ? styles.dropdownContainer : styles.dropdownContainerStatic} ${isLoading ? styles.loading : ""}`}
  >
    {children}
    {isLoading && (
      <div className={styles.loadingIndicator}>
        <div className={styles.loadingBar}></div>
      </div>
    )}
  </div>
);

LoadingWrapper.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export default LoadingWrapper;
